const frameTypes = {
    SINGLE_MAP: 'SINGLE_MAP',
    MAP_EDITOR: 'MAP_EDITOR',
};

export default frameTypes;
